import React, {useCallback, useMemo} from 'react';
import {Select} from "antd";
import {GameDto} from "../../games/types";
import {useQuery} from "react-query";
import axios, {AxiosResponse} from "axios";

export type GameSelectorProps = {
    value?: string[],
    onChange?: (value: string[] | undefined) => void;
    loading?: boolean;
}

export const MultiGameSelector: React.FC<GameSelectorProps> = (props) => {
    const {data: allGames} = useQuery({
        queryKey: `api-launcher-all-ttrpg-games`,
        queryFn: () => axios.get<object, AxiosResponse<GameDto[]>>(`/api/launcher/games`).then(r => r.data)
    });
    const {value, onChange, loading} = props;
    const normalisedGames = useMemo<GameDto[]>(() => allGames || [], [allGames]);
    const internalOnChange = useCallback((changed: string[] | null) => {
        if (!onChange) {
            return;
        }
        const externalValue = normalisedGames.filter((game) => changed?.includes(game.id));
        onChange(externalValue?.map(game => game.id));
    }, [normalisedGames]);


    return (
        <Select value={value} onChange={internalOnChange} loading={loading} mode={"tags"} showSearch autoClearSearchValue >
            {normalisedGames.map((game) => <Select.Option key={game.id} value={game.id}>{game.title}</Select.Option>)}
        </Select>
    );
}